import React, {useEffect, useState} from 'react';
import {useHistory, useParams, Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import {ProgressSpinner} from 'primereact/progressspinner';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {loadCurrentProfile} from '../../utils/currentProfile';

const RegistrationOnboardingPage = (props) => {
  const {t} = props;
  const history = useHistory();
  const {token: pathToken} = useParams();
  const hashQuery = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '';
  const queryToken = new URLSearchParams(hashQuery).get('token');
  const token = pathToken || queryToken;
  const endpoint = props.subscriptionOnboarding ? '/api/v2/registration/subscription-onboarding/' : '/api/v2/registration/onboarding/';
  const [loading, setLoading] = useState(true);
  const [startLoading, setStartLoading] = useState(false);
  const [onboardingData, setOnboardingData] = useState(null);
  const [error, setError] = useState('');

  const decodeJwt = (jwtToken) => {
    try {
      const payload = jwtToken.substring(jwtToken.indexOf('.') + 1, jwtToken.lastIndexOf('.'));
      return JSON.parse(decodeURIComponent(escape(atob(payload))));
    } catch (e) {
      return {};
    }
  };

  const clearStoredModules = () => {
    Object.keys(localStorage)
      .filter(key => key.startsWith('module_'))
      .forEach(key => localStorage.removeItem(key));
  };

  const storeAuthData = (data) => {
    const jwtData = decodeJwt(data.token);
    const user = data.user || {};
    const network = data.network || {};

    localStorage.setItem('userToken', data.token);
    localStorage.setItem('userId', user.id || jwtData.id || '');
    localStorage.setItem('userName', user.email || jwtData.username || '');
    localStorage.setItem('userRealName', user.name || jwtData.name || '');
    localStorage.setItem('userEmail', user.email || jwtData.username || '');
    localStorage.setItem('roles', '[]');
    localStorage.setItem('networkId', network.id || '');
    localStorage.setItem('networkName', network.name || '');
    localStorage.setItem('onboarding', data.onboarding ? 'true' : 'false');
    localStorage.setItem('firstLogin', data.firstLogin ? 'true' : 'false');
  };

  const loadModules = (data) => {
    clearStoredModules();

    return axios.get(process.env.REACT_APP_API_HOST + '/api/v2/modules', {
      headers: {
        'Authorization': 'Bearer ' + data.token,
        'App-Network': data.network?.id || ''
      }
    })
      .then(response => {
        Object.entries(response.data || {}).forEach((item) => {
          const mod = item[1];
          localStorage.setItem('module_' + mod.code, mod.name);
          if (mod.dashboard && mod.dashboard.id) {
            localStorage.setItem('module_' + mod.code + '_dashboard', mod.dashboard.id);
          }
        });
      });
  };

  const startApp = () => {
    if (!onboardingData) {
      return;
    }

    setStartLoading(true);
    storeAuthData(onboardingData);
    loadCurrentProfile().then(() => loadModules(onboardingData))
      .then(() => {
        document.getElementById('body').classList.remove('outside');
        if (window.App) {
          if (typeof window.App.setupAutoLogout === 'function') {
            window.App.setupAutoLogout();
          }
          window.App.setState({
            loggedIn: true,
            networks: onboardingData.network ? [onboardingData.network] : []
          }, () => {
            if (typeof window.App.networkSelect === 'function') {
              window.App.networkSelect();
            }
            if (typeof window.App.loadReceiptGroups === 'function') {
              window.App.loadReceiptGroups();
            }
            window.App.forceUpdate();
            history.replace('/');
          });
        } else {
          history.replace('/');
        }
      })
      .catch(error => {
        setStartLoading(false);
        if (window.App && typeof window.App.toastShow === 'function') {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        } else {
          setError('Hiba történt az alkalmazás indítása közben.');
        }
      });
  };

  useEffect(() => {
    document.title = 'Onboarding' + ' - ' + process.env.REACT_APP_TITLE;
    document.getElementById('body').classList.add('outside');

    Promise.all([
      axios.post(process.env.REACT_APP_API_HOST + endpoint + token),
      new Promise(resolve => setTimeout(resolve, 2000))
    ])
      .then(([response]) => {
        setOnboardingData(response.data.data);
        setLoading(false);
      })
      .catch(() => {
        setError('A regisztrációs link érvénytelen vagy lejárt.');
        setLoading(false);
      });
  }, [token, endpoint]);

  return (
    <div className="p-component" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f6f8',
      padding: '2rem'
    }}>
      {loading ? (
        <div className="p-text-center">
          <ProgressSpinner style={{width: '96px', height: '96px'}} strokeWidth="4"/>
          <h2 className="p-mt-4">Bejelentkezés folyamatban...</h2>
        </div>
      ) : error ? (
        <div className="p-text-center">
          <h2>Onboarding</h2>
          <p className="p-error">{error}</p>
          <Link to="/login">Bejelentkezés</Link>
        </div>
      ) : (
        <div className="p-text-center">
          <h2>Onboarding</h2>
          <Button
            label={t('start')}
            className="p-button-success p-mt-3"
            loading={startLoading}
            onClick={startApp}
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation('common')(RegistrationOnboardingPage);
